import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Lock from '@material-ui/icons/Lock'
import { RenderedFunctionComponent } from 'components/initComponents'
import { RootContainer } from 'components/RootContainer/RootContainer'
import React from 'react'
import { scopedTranslation } from 'src/helpers'

import { useStyles } from './LawSection.styles'

const { t } = scopedTranslation('application.footer')

export const LawSection: RenderedFunctionComponent = () => {
  const classes = useStyles()

  // TODO: somehow breakpoints are sets to material-ui
  // default values when trying to use theme ones,
  // further investigation is required
  const isMobileView = useMediaQuery('@media (max-width: 991px)')

  const href = 'https://www.bonitaetsmanager.de/nutzungsbedingungen'
  const rel = undefined
  const target = '_self'

  return (
    <RootContainer hasBackground={ false }>
      <Box className={ classes.section }>
        <Box className={ classes.navigation } component='nav'>
          <Link
            className={ classes.link }
            data-track-context='Footer'
            data-track-element='Footer_AGB'
            href={ href }
            target={ target }
            rel={ rel }
          >
            <Typography color='inherit' component='span' variant='body2'>
              {t('GTC')}
            </Typography>
          </Link>
          <Link
            className={ classes.link }
            data-track-context='Footer'
            data-track-element='Footer_AVV'
            href='https://www.bonitaetsmanager.de/avv'
          >
            <Typography color='inherit' component='span' variant='body2'>
              {t('AVV')}
            </Typography>
          </Link>
          <Link
            className={ classes.link }
            data-track-context='Footer'
            data-track-element='Footer_Datenschutz'
            href='https://www.bonitaetsmanager.de/datenschutz'
          >
            <Typography color='inherit' component='span' variant='body2'>
              {t('data_protection')}
            </Typography>
          </Link>
          <Link
            className={ classes.link }
            data-track-context='Footer'
            data-track-element='Footer_Impressum'
            href='https://www.bonitaetsmanager.de/impressum'
          >
            <Typography color='inherit' component='span' variant='body2'>
              {t('imprint')}
            </Typography>
          </Link>
        </Box>
        {!isMobileView && (
          <Box alignItems='center' display='flex' justifyContent='space-between' flexWrap='wrap'>
            <Typography className={ classes.text } component='p' variant='body2'>
              {t('boniM_is')}
            </Typography>
            <Box alignItems='center' display='flex'>
              <Lock className={ classes.icon } />
              <Typography className={ classes.text } component='p' variant='body2'>
                {t('secured_by_ssl')}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </RootContainer>
  )
}

LawSection.queryString = 'div.law-section'
